import { useMemo } from 'react';
import { useRecoilValue } from 'recoil';
import { isMobileState } from '@/state/session';
export const useInputAttributes = () => {
    const isMobile = useRecoilValue(isMobileState);
    const extraAttributes = useMemo(() => isMobile
        ? {
            autoCapitalize: 'off',
            autoComplete: 'off',
            autoCorrect: 'off',
            spellCheck: 'false',
        }
        : {}, [isMobile]);
    return {
        extraAttributes,
    };
};
